<template>
  <span>
    <el-dropdown trigger="click" placement="bottom-start">
      <span class="el-dropdown-link">
        <i slot="reference" class="el-icon-caret-bottom" />
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item>
          <el-popover popper-class="content" placement="right" width="180" trigger="hover">
            <div slot="reference">修改广告</div>
          </el-popover>
        </el-dropdown-item>
        <el-dropdown-item>
          <el-popover popper-class="content" placement="right" width="180" trigger="hover">
            <div slot="reference">修改创意</div>
          </el-popover>
        </el-dropdown-item>
        <el-dropdown-item>
          <el-popover popper-class="content" placement="right" width="180" trigger="hover">
            <div>
              <div>在广告暂停前拉取到广告的部分用户可能在广告暂停后才看到或点击广告，因此广告暂停后仍可能会产生一些花费。</div>
              <a>详细了解</a>
            </div>
            <div slot="reference">暂停投放</div>
          </el-popover>
        </el-dropdown-item>
        <el-dropdown-item>
          <el-popover popper-class="content" placement="right" width="180" trigger="hover">
            <div slot="reference">修改时间</div>
          </el-popover>
        </el-dropdown-item>
        <el-dropdown-item>
          <el-popover popper-class="content" placement="right" width="180" trigger="hover">
            <div slot="reference">复制计划</div>
          </el-popover>
        </el-dropdown-item>
        <el-dropdown-item disabled>
          <el-popover popper-class="content" placement="right" width="180" trigger="hover">
            <div slot="reference">删除计划</div>
          </el-popover>
        </el-dropdown-item>
        <el-dropdown-item>
          <el-popover popper-class="content" placement="right" width="180" trigger="hover">
            <div slot="reference">操作日志</div>
          </el-popover>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </span>
</template>

<script>
export default {
  name: 'LaunchOperate',
  data() {
    return {
    }
  }
}
</script>

<style>
  .content {
    margin-left: 30px!important;
  }
</style>
<style scoped lang="less">
  /deep/ .el-dropdown-menu__item {
    width: 120px;
  }
  /deep/ .el-dropdown-menu__item:hover {
    color: #333333;
    background-color: rgb(235,235,235);
  }
  a {
    color: #66b1ff;
  }
</style>
